import React, { useEffect, useState } from 'react';
import './BeltPromotionModal.css';
import { getBeltImage, getBeltColor } from './utils/beltHelper';

const BeltPromotionModal = ({ cinturon, beltData, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);

  if (!beltData) return null;

  const esPunta = cinturon.includes('Punta');
  const esDan = cinturon.includes('Dan');
  const beltColor = getBeltColor(cinturon);

  return (
    <div className={`belt-promotion-overlay ${show ? 'show' : ''}`} onClick={onClose}>
      <div className={`belt-promotion-modal ${show ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="belt-promotion-glow"></div>
        
        <div className="belt-promotion-content">
          <div className="belt-icon">
            {getBeltImage(cinturon) ? (
              <img src={getBeltImage(cinturon)} alt={cinturon} className="belt-promotion-image" />
            ) : (
              '🥋'
            )}
          </div>
          
          <h1 className="belt-title">¡NUEVO CINTURÓN!</h1>
          
          <div className="belt-name" style={{ 
            background: beltColor,
            color: cinturon.includes('Negro') || cinturon.includes('Azul') || cinturon.includes('Rojo') ? '#fff' : '#000',
            border: cinturon.includes('Negro') ? '3px solid #FFD700' : '3px solid rgba(0,0,0,0.3)',
            boxShadow: cinturon.includes('Negro') 
              ? '0 0 30px rgba(255,215,0,0.6), inset 0 0 20px rgba(255,255,255,0.1)'
              : '0 0 20px rgba(0,0,0,0.3), inset 0 0 20px rgba(255,255,255,0.3)',
            textShadow: cinturon.includes('Negro') || cinturon.includes('Azul') || cinturon.includes('Rojo') 
              ? '2px 2px 4px rgba(0,0,0,0.8)' 
              : '2px 2px 4px rgba(255,255,255,0.8)'
          }}>
            {cinturon}
          </div>
          
          <div className="belt-meaning">
            <h3>Significado</h3>
            <p>{beltData.significado}</p>
          </div>

          {esPunta && beltData.frase && (
            <div className="belt-quote">
              <div className="quote-icon">💪</div>
              <p className="quote-text">{beltData.frase}</p>
            </div>
          )}

          {esDan && beltData.frase_choi && (
            <div className="belt-quote choi">
              <div className="quote-icon">🎖️</div>
              <p className="quote-text">{beltData.frase_choi}</p>
            </div>
          )}

          {beltData.formas && beltData.formas.length > 0 && (
            <div className="belt-forms">
              <h3>Formas de este Cinturón</h3>
              {beltData.formas.map((forma, index) => (
                <div key={index} className="form-item">
                  <span className="form-name">{forma.nombre}</span>
                  <span className="form-moves">{forma.movimientos} movimientos</span>
                </div>
              ))}
            </div>
          )}
          
          <button className="belt-continue-button" onClick={onClose}>
            ¡CONTINUAR!
          </button>
        </div>
        
        <div className="belt-particles">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="belt-particle" style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BeltPromotionModal;
